exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".download-counter{margin-top:16px;color:#727e82}.document-download__file-select-all{margin-bottom:16px;padding-bottom:16px}.document-download__file-select{padding-bottom:16px}.document-download__attachments-section{padding-top:16px}.document-download__attachments-header{margin-bottom:16px;color:#727e82}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};